import { json } from '@codemirror/lang-json'
import CodeMirror from '@uiw/react-codemirror'
import { useAppSelector } from '../../store/Hooks'

interface P {
    value: object
    onChange?: (value: string) => void
    readOnly: boolean
}

const JSONEditor = ({ value, onChange, readOnly }: P) => {
    const formattedValue = JSON.stringify(value, null, 2)
    const mode = useAppSelector(state => state.app.mode)
    return (
        <CodeMirror
            readOnly={readOnly}
            value={formattedValue}
            height='100%'
            theme={mode === 'dark' ? 'dark' : 'light'}
            style={{ flex: 1, fontSize: '13px', overflow: 'auto' }}
            extensions={[json()]}
            onChange={value => onChange(value)}
        />
    )
}

export default JSONEditor
